<template>
  <Moveable
    ref="handler"
    class="draggable-signature"
    v-bind="moveable"
    :style="style"
    @drag="handleDrag"
    @drag-end="handleDragEnd"
  >
    <UserSignature
      :closable="closable"
      @close="$emit('close')"
    />
  </Moveable>
</template>

<script>

import Moveable from 'vue-moveable';

import UserSignature from '@/febos/global/pdf/components/UserSignature';
import DraggableSignatureBehaviors from '@/febos/global/pdf/mixins/DraggableSignatureBehaviors';

export default {
  mixins: [DraggableSignatureBehaviors],
  components: {
    Moveable,
    UserSignature
  },
  props: {
    closable: { type: Boolean, default: true }
  }
};

</script>
